import clsx from "clsx"
import { FC } from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "store/index"
import { FeaturesSelectors } from "store/slices/featuresSlice"
import { useMenuActiveState } from "hooks/useMenuActiveState"
import { useSpecialDeals } from "hooks/useSpecialDeals/useSpecialDeals"
import { hapticFeedback } from "utils/hapticFeedback"
import OutlinedText from "ui/outlinedText"
import { WalletDealBadge } from "./ui/wallet-deal-badge"
import { FooterIcon } from "../svg-icon"
import styles from "./index.module.scss"

export interface IFooterMenuItem {
  name: string
  id?: string
  titleKey: string
  url: string
  startUrl?: string
  disabled?: boolean
}

export const FooterMenuItem: FC<IFooterMenuItem> = ({
  name,
  id,
  url,
  titleKey,
  startUrl,
  disabled = false
}) => {
  const { t } = useTranslation()
  const { isMenuItemActive } = useMenuActiveState()

  const isPersonalDailyDealEnabled = useAppSelector(
    FeaturesSelectors.selectIsPersonalDailyDealEnabled()
  )

  const isWallet = name === "wallet"

  const { specialDeal } = useSpecialDeals(!isWallet)

  if (disabled) {
    return (
      <div className={clsx(styles.FooterMenuItem, styles.disabled)}>
        <div className={styles.FooterMenuItem}>
          <FooterIcon iconName={name} />
          <OutlinedText>{t(titleKey)}</OutlinedText>
        </div>
      </div>
    )
  }

  return (
    <div className={clsx(styles.FooterMenuItem)}>
      <NavLink
        id={id}
        to={url}
        end={!startUrl}
        className={({ isActive }) =>
          clsx(
            styles.FooterMenuItem,
            `hover-effect`,
            isMenuItemActive(url, startUrl, isActive) && styles.active
          )
        }
        onClick={() => {
          hapticFeedback()
        }}
      >
        <FooterIcon iconName={name} />
        <OutlinedText>{t(titleKey)}</OutlinedText>
        {isWallet && !!specialDeal && (
          <div className={styles.FooterMenuItem_specialDeal}>
            -{specialDeal.discountPercent}%
          </div>
        )}
        {isPersonalDailyDealEnabled && isWallet && !!id && <WalletDealBadge />}
      </NavLink>
    </div>
  )
}
